import React from "react";
import { Helmet } from "react-helmet";

// Site-wide structured data injected on every page (see gatsby-shared.js
// wrapPageElement). Organization is the #1 entity signal for AI answer engines;
// WebSite ties pages to the brand. No aggregateRating/Review markup here
// (penalty trap: Google requires a visible rating on the same page, and we make
// no front-end changes). No SearchAction either: the site has no on-site search,
// and a SearchAction pointing at a non-existent results page would be invalid.

const SITE_URL = "https://smart-plan.com";

const organization = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: "Smart Plan",
  legalName: "UK Boiler Company Ltd",
  url: SITE_URL,
  logo: `${SITE_URL}/images/smart-plan-logo.png`,
  image: `${SITE_URL}/images/smart-plan-default-og.png`,
  description:
    "Flexible UK home cover you build yourself: boiler cover and repair, new-boiler finance, home emergency and appliance protection. Trusted since 2014.",
  foundingDate: "2014-06-10",
  email: "hello@smart-plan.com",
  telephone: "+443337726247",
  areaServed: "GB",
  knowsAbout: [
    "Boiler cover",
    "Boiler repair",
    "Central heating cover",
    "Home emergency cover",
    "Appliance cover",
    "New boiler finance",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+443337726247",
    email: "hello@smart-plan.com",
    contactType: "customer service",
    areaServed: "GB",
    availableLanguage: "English",
  },
  sameAs: [
    "https://find-and-update.company-information.service.gov.uk/company/09078640",
    "https://www.trustpilot.com/review/smart-plan.com",
  ],
};

const website = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  name: "Smart Plan",
  url: SITE_URL,
  inLanguage: "en-GB",
  publisher: { "@id": `${SITE_URL}/#organization` },
};

const StructuredData = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(organization)}</script>
    <script type="application/ld+json">{JSON.stringify(website)}</script>
  </Helmet>
);

export default StructuredData;
